<template>
  <div>

  </div>
</template>

<script>
import * as xhr from '../api/xhr.js'
import * as qconst from '../vendor/qconstants';
import {getGlobalValue, getGlobalValueOrZero, setGlobalKeyValue} from "@/util/globalState";
import {ebus} from "@/vendor/ebus";

export default {
  data: () => ({}),
  created() {
    ebus.$on('appFocused', () => {
      this.loadInventoryData();
    });
  },
  beforeMount() {
    this.loadInventoryData();
  },
  mounted() {
    this.loadInventoryData();
  },
  methods: {
    async loadInventoryData(notifyUser) {
      if (!this.$store.state.enableBestand) {
        return;
      }
      let now = Date.now();
      let easer = getGlobalValueOrZero('loadInventoryData');
      if (!easer || now - parseInt(easer) > 10 * 1000) {
        setGlobalKeyValue('loadInventoryData', now);
      } else {
        //eased
        return;
      }

      let storeId = "1";
      let msg = {
        action: qconst.action$qsignal_LoadDocs,
        collectionName: 'inventoryDataStore' + storeId,
        // businessPrefix: true,
        query: {
          // itemIdType: itemIdType,
          enabled: true,
        }
      };
      //triggers a broadcast to waiters
      await xhr.xhrSend(true, msg, (data) => {
        if (data?.ok && data.docs) {
          setGlobalKeyValue('inventoryData', data.docs);
          console.log('number of enabled inventoryData loaded: ' + data.docs.length)
        } else {
          console.log('error loading inventoryDataStore');
          //retry
          setTimeout(() => {
            this.loadInventoryData();
          }, 10 * 1000);
        }
      }, (err) => {
        console.log('unexpected error loading inventoryDataStore');

        //retry
        setTimeout(() => {
          this.loadInventoryData();
        }, 10 * 1000);
      });
    },

  },
}
</script>

<style scoped>

</style>
